import { query_project_card_can_use_select } from '@/api/mjstore-model';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY } from '@/store/mutation-type';
import cacheRemoteSelect from '@/components/FormRender/utils';

const org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
const search_config: any = {
  model: {
    org_id: org?.id,
    is_active: true,
    card_record_id: undefined,
    pageSize: 2000,
  },
  watch: ['card_record_id'],
};

export default (modelType?: string) => {
  return {
    getData: cacheRemoteSelect(query_project_card_can_use_select, modelType),
    searchConfig: search_config,
  };
};
